import {
  Box,
  Button,
  ButtonBase,
  Grid,
  Paper,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const GridContainer = styled(Grid)(() => ({
  padding: '32px 32px 32px 120px',
  backgroundColor: '#FAFCFF',
}));

export const FilledButton = styled(Button)(() => ({
  borderRadius: '16px',
  width: '100%',
}));

export const IconButtonBase = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  padding: '2px 4px',
  borderRadius: '8px',
  alignItems: 'center',
  fontSize: '16px',
  '& span': { color: theme.palette.secondary.main },
  '&:hover': {
    '& span': {
      fontSize: '26px',
    },
    fontWeight: '600',
  },
}));

export const GridQuestions = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}));

export const TitleQuestions = styled(Typography)(() => ({
  fontSize: '21px',
  fontWeight: '600',
}));

export const PaperQuestions = styled(Paper)(({ theme }) => ({
  height: '560px',
  overflowY: 'auto',
  backgroundColor: '#FAFCFF',
  border: '1px solid #0000003b',
  borderRadius: '16px',
  padding: '8px',
  marginBottom: '20px',
  '&::-webkit-scrollbar': {
    width: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&::-webkit-scrollbar-track': {
    margin: '6px 0',
  },
  [theme.breakpoints.up('xl')]: {
    height: '660px',
  },
}));

export const GridButton = styled(Grid)(() => ({
  display: 'flex',
  gap: '20px',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: '10px',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '16px',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '40px',
}));

export const FilledDarkButton = styled(Button)(({ theme }) => ({
  borderRadius: '16px',
  width: '100%',
  backgroundColor: theme.palette.secondary.main,
  color: '#FAFCFF',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));
